import LinkCard from '@/pages/links/components/LinkCard';

// Foto de perfil do Ednilson (anexada pelo usuário)
const AVATAR_URL = '/media/produtos/0473.png';

type LinkItem = {
  icon: string;
  label: string;
  subtitle?: string;
  to?: string;
  href?: string;
  external?: boolean;
  variant?: 'primary' | 'default';
};

const links: LinkItem[] = [
  {
    icon: 'ri-home-5-line',
    label: 'HomeOffice Premium',
    subtitle: 'Site oficial — móveis corporativos',
    to: '/',
  },
  {
    icon: 'ri-government-line',
    label: 'Inteligência Licitação',
    subtitle: 'Soluções e consultoria em licitações',
    href: 'https://inteligencialicitacao.com/',
    external: true,
  },
  {
    icon: 'ri-shopping-cart-2-line',
    label: 'Catálogo interativo',
    subtitle: 'Cadastre-se, monte o carrinho e peça pelo WhatsApp',
    href: 'https://readdy.cc/preview/fcf5ab1e-d06e-40e9-9e86-c6d9d8062e00/13441890/auth',
    external: true,
  },
  {
    icon: 'ri-article-line',
    label: 'Blog',
    subtitle: 'Conteúdos sobre ambientes e mobiliário',
    to: '/blog',
  },
  {
    icon: 'ri-youtube-line',
    label: 'YouTube',
    subtitle: 'Vídeos e projetos',
    href: 'https://www.youtube.com/channel/UC3BsTtRw9BYTYosHOT0E_Ew',
    external: true,
  },
  {
    icon: 'ri-map-pin-line',
    label: 'Localização do showroom',
    subtitle: 'Av. Agamenon Magalhães, 1519 — Caruaru, PE',
    href: 'https://www.google.com/maps/search/?api=1&query=Av.+Agamenon+Magalh%C3%A3es%2C+1519%2C+Maur%C3%ADcio+de+Nassau%2C+Caruaru+-+PE',
    external: true,
  },
  {
    icon: 'ri-book-2-line',
    label: 'E-books gratuitos',
    subtitle: 'Guias para montar seu ambiente',
    to: '/ebooks',
  },
  {
    icon: 'ri-calculator-line',
    label: 'Calculadora de orçamento',
    subtitle: 'Estime seu investimento',
    to: '/calculadora',
  },
  {
    icon: 'ri-building-4-line',
    label: 'Projetos realizados',
    subtitle: 'Cases e entregas da HomeOffice',
    to: '/cases',
  },
  {
    icon: 'ri-presentation-line',
    label: 'Apresentação HomeOffice Premium',
    subtitle: 'Nosso portfólio e soluções completas',
    href: '/media/docs/-4965-9f06-1763f35b4463_homeoffice_premium_apresentacao_atualizada.pdf',
    external: true,
  },
  {
    icon: 'ri-heart-3-line',
    label: 'Caixinha de Ajuda',
    subtitle: 'Indique alguém que precisa de uma mão',
    to: '/caixinha-de-ajuda',
  },
];

export default function EdnilsonLeocadioPage() {
  return (
    <main className="min-h-screen bg-hop-bg-alt relative overflow-hidden">
      {/* Brilhos decorativos */}
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-hop-orange/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-[420px] h-[420px] bg-hop-orange/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative max-w-xl mx-auto px-5 md:px-6 py-12 md:py-16">
        {/* Cabeçalho */}
        <header className="flex flex-col items-center text-center mb-8 md:mb-10 hop-fade-up">
          <div className="w-24 h-24 md:w-28 md:h-28 rounded-full overflow-hidden border-3 border-hop-orange/30 shadow-md mb-4">
            <img
              src={AVATAR_URL}
              alt="Ednilson Leocádio"
              className="w-full h-full object-cover"
            />
          </div>
          <h1 className="text-2xl md:text-3xl font-extrabold text-hop-graphite tracking-tight">
            Ednilson Leocádio
          </h1>
          <p className="text-hop-text-primary text-sm md:text-base font-light mt-1">
            Móveis corporativos & Mentor de licitações
          </p>
          <span className="inline-flex items-center gap-1.5 mt-3 bg-hop-orange/10 text-hop-orange text-xs md:text-sm font-semibold px-3 py-1.5 rounded-full">
            <i className="ri-map-pin-line text-xs"></i>
            Caruaru, Pernambuco
          </span>
        </header>

        {/* Links */}
        <div className="flex flex-col gap-3">
          {links.map((link, i) => (
            <div key={link.label} className="hop-fade-up" style={{ animationDelay: `${120 + i * 55}ms` }}>
              <LinkCard {...link} />
            </div>
          ))}
        </div>

        {/* Rodapé */}
        <footer className="text-center mt-10 md:mt-12 hop-fade-up" style={{ animationDelay: '900ms' }}>
          <p className="text-hop-text-secondary text-xs font-light leading-relaxed">
            Do projeto à montagem, soluções completas em mobiliário corporativo.
            <br />
            HomeOffice Premium — Caruaru, Pernambuco
          </p>
        </footer>
      </div>
    </main>
  );
}